/* tslint:disable */
/* eslint-disable */
/**
 * OpenAPI definition
 * No description provided (generated by Openapi Generator https://github.com/openapitools/openapi-generator)
 *
 * The version of the OpenAPI document: v0
 * 
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */


import * as runtime from '../runtime';
import type {
  AddBotMessageRequest,
  FullOfferUi,
  PersonalizedVehicleDescriptionResponse,
  SaveInitialBotMessageRequest,
  SaveMessageFeedbackRequest,
  SaveSurveyRequest,
  SetStopTranscriptSendingRequest,
  VehicleDetailsCardDTO,
  VehicleHeaderCardDTO,
  WidgetChatHistoryResponse,
  WidgetChatInitializeResponse,
  WidgetChatMessage,
  WidgetChatRequest,
  WidgetChatResponse,
  WidgetSettings,
  WidgetUserInitializationResponse,
} from '../models';

export interface AddBotMessageOperationRequest {
    chatId: string;
    addBotMessageRequest: AddBotMessageRequest;
}

export interface DeleteMessageFeedbackRequest {
    chatId: string;
    messageId: number;
}

export interface GetChatHistoryRequest {
    chatId: string;
}

export interface GetFullOfferUiByPublicIdRequest {
    publicOfferId: string;
}

export interface GetPersonalizedVehicleDescriptionRequest {
    publicBotId: string;
    vin: string;
    chatId: string;
    locale: GetPersonalizedVehicleDescriptionLocaleEnum;
}

export interface GetStopTranscriptSendingRequest {
    chatId: string;
}

export interface GetVehicleDetailsCardContentRequest {
    publicBotId: string;
    vin: string;
    locale: GetVehicleDetailsCardContentLocaleEnum;
}

export interface GetVehicleDetailsCardContentByNewVehicleIdRequest {
    publicBotId: string;
    newVehicleId: string;
    locale: GetVehicleDetailsCardContentByNewVehicleIdLocaleEnum;
}

export interface GetVehicleHeaderCardDataByNewVehicleIdRequest {
    publicBotId: string;
    newVehicleId: string;
    locale: GetVehicleHeaderCardDataByNewVehicleIdLocaleEnum;
}

export interface GetVehicleHeaderCardDataByVinRequest {
    publicBotId: string;
    vin: string;
    locale: GetVehicleHeaderCardDataByVinLocaleEnum;
}

export interface GetVehicleHeaderCardDataByVrmRequest {
    publicBotId: string;
    vrm: string;
    locale: GetVehicleHeaderCardDataByVrmLocaleEnum;
}

export interface GetWidgetSettingsRequest {
    publicBotId: string;
    locale?: GetWidgetSettingsLocaleEnum;
    ignoreConversationLimits?: boolean;
}

export interface InitializeUserRequest {
    publicBotId: string;
}

export interface QueryRequest {
    widgetChatRequest: WidgetChatRequest;
}

export interface SaveInitialBotMessageOperationRequest {
    chatId: string;
    saveInitialBotMessageRequest: SaveInitialBotMessageRequest;
}

export interface SaveMessageFeedbackOperationRequest {
    chatId: string;
    messageId: number;
    saveMessageFeedbackRequest: SaveMessageFeedbackRequest;
}

export interface SaveSurveyOperationRequest {
    chatId: string;
    saveSurveyRequest: SaveSurveyRequest;
}

export interface SetStopTranscriptSendingOperationRequest {
    chatId: string;
    setStopTranscriptSendingRequest: SetStopTranscriptSendingRequest;
}

/**
 * 
 */
export class WidgetControllerApi extends runtime.BaseAPI {

    /**
     */
    async addBotMessageRaw(requestParameters: AddBotMessageOperationRequest, initOverrides?: RequestInit | runtime.InitOverrideFunction): Promise<runtime.ApiResponse<WidgetChatMessage>> {
        if (requestParameters['chatId'] == null) {
            throw new runtime.RequiredError(
                'chatId',
                'Required parameter "chatId" was null or undefined when calling addBotMessage().'
            );
        }

        if (requestParameters['addBotMessageRequest'] == null) {
            throw new runtime.RequiredError(
                'addBotMessageRequest',
                'Required parameter "addBotMessageRequest" was null or undefined when calling addBotMessage().'
            );
        }

        const queryParameters: any = {};

        const headerParameters: runtime.HTTPHeaders = {};

        headerParameters['Content-Type'] = 'application/json';

        const response = await this.request({
            path: `/api/public/widget/{chatId}/add-bot-message`.replace(`{${"chatId"}}`, encodeURIComponent(String(requestParameters['chatId']))),
            method: 'POST',
            headers: headerParameters,
            query: queryParameters,
            body: requestParameters['addBotMessageRequest'],
        }, initOverrides);

        return new runtime.JSONApiResponse(response);
    }

    /**
     */
    async addBotMessage(requestParameters: AddBotMessageOperationRequest, initOverrides?: RequestInit | runtime.InitOverrideFunction): Promise<WidgetChatMessage> {
        const response = await this.addBotMessageRaw(requestParameters, initOverrides);
        return await response.value();
    }

    /**
     */
    async deleteMessageFeedbackRaw(requestParameters: DeleteMessageFeedbackRequest, initOverrides?: RequestInit | runtime.InitOverrideFunction): Promise<runtime.ApiResponse<void>> {
        if (requestParameters['chatId'] == null) {
            throw new runtime.RequiredError(
                'chatId',
                'Required parameter "chatId" was null or undefined when calling deleteMessageFeedback().'
            );
        }

        if (requestParameters['messageId'] == null) {
            throw new runtime.RequiredError(
                'messageId',
                'Required parameter "messageId" was null or undefined when calling deleteMessageFeedback().'
            );
        }

        const queryParameters: any = {};

        const headerParameters: runtime.HTTPHeaders = {};

        const response = await this.request({
            path: `/api/public/widget/{chatId}/messages/{messageId}/feedback`.replace(`{${"chatId"}}`, encodeURIComponent(String(requestParameters['chatId']))).replace(`{${"messageId"}}`, encodeURIComponent(String(requestParameters['messageId']))),
            method: 'DELETE',
            headers: headerParameters,
            query: queryParameters,
        }, initOverrides);

        return new runtime.VoidApiResponse(response);
    }

    /**
     */
    async deleteMessageFeedback(requestParameters: DeleteMessageFeedbackRequest, initOverrides?: RequestInit | runtime.InitOverrideFunction): Promise<void> {
        await this.deleteMessageFeedbackRaw(requestParameters, initOverrides);
    }

    /**
     */
    async getChatHistoryRaw(requestParameters: GetChatHistoryRequest, initOverrides?: RequestInit | runtime.InitOverrideFunction): Promise<runtime.ApiResponse<WidgetChatHistoryResponse>> {
        if (requestParameters['chatId'] == null) {
            throw new runtime.RequiredError(
                'chatId',
                'Required parameter "chatId" was null or undefined when calling getChatHistory().'
            );
        }

        const queryParameters: any = {};

        const headerParameters: runtime.HTTPHeaders = {};

        const response = await this.request({
            path: `/api/public/widget/history/{chatId}`.replace(`{${"chatId"}}`, encodeURIComponent(String(requestParameters['chatId']))),
            method: 'POST',
            headers: headerParameters,
            query: queryParameters,
        }, initOverrides);

        return new runtime.JSONApiResponse(response);
    }

    /**
     */
    async getChatHistory(requestParameters: GetChatHistoryRequest, initOverrides?: RequestInit | runtime.InitOverrideFunction): Promise<WidgetChatHistoryResponse> {
        const response = await this.getChatHistoryRaw(requestParameters, initOverrides);
        return await response.value();
    }

    /**
     */
    async getFullOfferUiByPublicIdRaw(requestParameters: GetFullOfferUiByPublicIdRequest, initOverrides?: RequestInit | runtime.InitOverrideFunction): Promise<runtime.ApiResponse<FullOfferUi>> {
        if (requestParameters['publicOfferId'] == null) {
            throw new runtime.RequiredError(
                'publicOfferId',
                'Required parameter "publicOfferId" was null or undefined when calling getFullOfferUiByPublicId().'
            );
        }

        const queryParameters: any = {};

        const headerParameters: runtime.HTTPHeaders = {};

        const response = await this.request({
            path: `/api/public/widget/offer-card/{publicOfferId}`.replace(`{${"publicOfferId"}}`, encodeURIComponent(String(requestParameters['publicOfferId']))),
            method: 'GET',
            headers: headerParameters,
            query: queryParameters,
        }, initOverrides);

        return new runtime.JSONApiResponse(response);
    }

    /**
     */
    async getFullOfferUiByPublicId(requestParameters: GetFullOfferUiByPublicIdRequest, initOverrides?: RequestInit | runtime.InitOverrideFunction): Promise<FullOfferUi> {
        const response = await this.getFullOfferUiByPublicIdRaw(requestParameters, initOverrides);
        return await response.value();
    }

    /**
     */
    async getPersonalizedVehicleDescriptionRaw(requestParameters: GetPersonalizedVehicleDescriptionRequest, initOverrides?: RequestInit | runtime.InitOverrideFunction): Promise<runtime.ApiResponse<PersonalizedVehicleDescriptionResponse>> {
        if (requestParameters['publicBotId'] == null) {
            throw new runtime.RequiredError(
                'publicBotId',
                'Required parameter "publicBotId" was null or undefined when calling getPersonalizedVehicleDescription().'
            );
        }

        if (requestParameters['vin'] == null) {
            throw new runtime.RequiredError(
                'vin',
                'Required parameter "vin" was null or undefined when calling getPersonalizedVehicleDescription().'
            );
        }

        if (requestParameters['chatId'] == null) {
            throw new runtime.RequiredError(
                'chatId',
                'Required parameter "chatId" was null or undefined when calling getPersonalizedVehicleDescription().'
            );
        }

        if (requestParameters['locale'] == null) {
            throw new runtime.RequiredError(
                'locale',
                'Required parameter "locale" was null or undefined when calling getPersonalizedVehicleDescription().'
            );
        }

        const queryParameters: any = {};

        if (requestParameters['locale'] != null) {
            queryParameters['locale'] = requestParameters['locale'];
        }

        const headerParameters: runtime.HTTPHeaders = {};

        const response = await this.request({
            path: `/api/public/widget/vehicle-card/bot/{publicBotId}/vin/{vin}/chat/{chatId}/description`.replace(`{${"publicBotId"}}`, encodeURIComponent(String(requestParameters['publicBotId']))).replace(`{${"vin"}}`, encodeURIComponent(String(requestParameters['vin']))).replace(`{${"chatId"}}`, encodeURIComponent(String(requestParameters['chatId']))),
            method: 'GET',
            headers: headerParameters,
            query: queryParameters,
        }, initOverrides);

        return new runtime.JSONApiResponse(response);
    }

    /**
     */
    async getPersonalizedVehicleDescription(requestParameters: GetPersonalizedVehicleDescriptionRequest, initOverrides?: RequestInit | runtime.InitOverrideFunction): Promise<PersonalizedVehicleDescriptionResponse> {
        const response = await this.getPersonalizedVehicleDescriptionRaw(requestParameters, initOverrides);
        return await response.value();
    }

    /**
     */
    async getStopTranscriptSendingRaw(requestParameters: GetStopTranscriptSendingRequest, initOverrides?: RequestInit | runtime.InitOverrideFunction): Promise<runtime.ApiResponse<SetStopTranscriptSendingRequest>> {
        if (requestParameters['chatId'] == null) {
            throw new runtime.RequiredError(
                'chatId',
                'Required parameter "chatId" was null or undefined when calling getStopTranscriptSending().'
            );
        }

        const queryParameters: any = {};

        const headerParameters: runtime.HTTPHeaders = {};

        const response = await this.request({
            path: `/api/public/widget/{chatId}/stop-transcript-sending`.replace(`{${"chatId"}}`, encodeURIComponent(String(requestParameters['chatId']))),
            method: 'GET',
            headers: headerParameters,
            query: queryParameters,
        }, initOverrides);

        return new runtime.JSONApiResponse(response);
    }

    /**
     */
    async getStopTranscriptSending(requestParameters: GetStopTranscriptSendingRequest, initOverrides?: RequestInit | runtime.InitOverrideFunction): Promise<SetStopTranscriptSendingRequest> {
        const response = await this.getStopTranscriptSendingRaw(requestParameters, initOverrides);
        return await response.value();
    }

    /**
     */
    async getVehicleDetailsCardContentRaw(requestParameters: GetVehicleDetailsCardContentRequest, initOverrides?: RequestInit | runtime.InitOverrideFunction): Promise<runtime.ApiResponse<VehicleDetailsCardDTO>> {
        if (requestParameters['publicBotId'] == null) {
            throw new runtime.RequiredError(
                'publicBotId',
                'Required parameter "publicBotId" was null or undefined when calling getVehicleDetailsCardContent().'
            );
        }

        if (requestParameters['vin'] == null) {
            throw new runtime.RequiredError(
                'vin',
                'Required parameter "vin" was null or undefined when calling getVehicleDetailsCardContent().'
            );
        }

        if (requestParameters['locale'] == null) {
            throw new runtime.RequiredError(
                'locale',
                'Required parameter "locale" was null or undefined when calling getVehicleDetailsCardContent().'
            );
        }

        const queryParameters: any = {};

        if (requestParameters['locale'] != null) {
            queryParameters['locale'] = requestParameters['locale'];
        }

        const headerParameters: runtime.HTTPHeaders = {};

        const response = await this.request({
            path: `/api/public/widget/vehicle-card/bot/{publicBotId}/vin/{vin}`.replace(`{${"publicBotId"}}`, encodeURIComponent(String(requestParameters['publicBotId']))).replace(`{${"vin"}}`, encodeURIComponent(String(requestParameters['vin']))),
            method: 'GET',
            headers: headerParameters,
            query: queryParameters,
        }, initOverrides);

        return new runtime.JSONApiResponse(response);
    }

    /**
     */
    async getVehicleDetailsCardContent(requestParameters: GetVehicleDetailsCardContentRequest, initOverrides?: RequestInit | runtime.InitOverrideFunction): Promise<VehicleDetailsCardDTO> {
        const response = await this.getVehicleDetailsCardContentRaw(requestParameters, initOverrides);
        return await response.value();
    }

    /**
     */
    async getVehicleDetailsCardContentByNewVehicleIdRaw(requestParameters: GetVehicleDetailsCardContentByNewVehicleIdRequest, initOverrides?: RequestInit | runtime.InitOverrideFunction): Promise<runtime.ApiResponse<VehicleDetailsCardDTO>> {
        if (requestParameters['publicBotId'] == null) {
            throw new runtime.RequiredError(
                'publicBotId',
                'Required parameter "publicBotId" was null or undefined when calling getVehicleDetailsCardContentByNewVehicleId().'
            );
        }

        if (requestParameters['newVehicleId'] == null) {
            throw new runtime.RequiredError(
                'newVehicleId',
                'Required parameter "newVehicleId" was null or undefined when calling getVehicleDetailsCardContentByNewVehicleId().'
            );
        }

        if (requestParameters['locale'] == null) {
            throw new runtime.RequiredError(
                'locale',
                'Required parameter "locale" was null or undefined when calling getVehicleDetailsCardContentByNewVehicleId().'
            );
        }

        const queryParameters: any = {};

        if (requestParameters['locale'] != null) {
            queryParameters['locale'] = requestParameters['locale'];
        }

        const headerParameters: runtime.HTTPHeaders = {};

        const response = await this.request({
            path: `/api/public/widget/vehicle-card/bot/{publicBotId}/new-vehicle-id/{newVehicleId}`.replace(`{${"publicBotId"}}`, encodeURIComponent(String(requestParameters['publicBotId']))).replace(`{${"newVehicleId"}}`, encodeURIComponent(String(requestParameters['newVehicleId']))),
            method: 'GET',
            headers: headerParameters,
            query: queryParameters,
        }, initOverrides);

        return new runtime.JSONApiResponse(response);
    }

    /**
     */
    async getVehicleDetailsCardContentByNewVehicleId(requestParameters: GetVehicleDetailsCardContentByNewVehicleIdRequest, initOverrides?: RequestInit | runtime.InitOverrideFunction): Promise<VehicleDetailsCardDTO> {
        const response = await this.getVehicleDetailsCardContentByNewVehicleIdRaw(requestParameters, initOverrides);
        return await response.value();
    }

    /**
     */
    async getVehicleHeaderCardDataByNewVehicleIdRaw(requestParameters: GetVehicleHeaderCardDataByNewVehicleIdRequest, initOverrides?: RequestInit | runtime.InitOverrideFunction): Promise<runtime.ApiResponse<VehicleHeaderCardDTO>> {
        if (requestParameters['publicBotId'] == null) {
            throw new runtime.RequiredError(
                'publicBotId',
                'Required parameter "publicBotId" was null or undefined when calling getVehicleHeaderCardDataByNewVehicleId().'
            );
        }

        if (requestParameters['newVehicleId'] == null) {
            throw new runtime.RequiredError(
                'newVehicleId',
                'Required parameter "newVehicleId" was null or undefined when calling getVehicleHeaderCardDataByNewVehicleId().'
            );
        }

        if (requestParameters['locale'] == null) {
            throw new runtime.RequiredError(
                'locale',
                'Required parameter "locale" was null or undefined when calling getVehicleHeaderCardDataByNewVehicleId().'
            );
        }

        const queryParameters: any = {};

        if (requestParameters['locale'] != null) {
            queryParameters['locale'] = requestParameters['locale'];
        }

        const headerParameters: runtime.HTTPHeaders = {};

        const response = await this.request({
            path: `/api/public/widget/vehicle-header-card/bot/{publicBotId}/new-vehicle-id/{newVehicleId}`.replace(`{${"publicBotId"}}`, encodeURIComponent(String(requestParameters['publicBotId']))).replace(`{${"newVehicleId"}}`, encodeURIComponent(String(requestParameters['newVehicleId']))),
            method: 'GET',
            headers: headerParameters,
            query: queryParameters,
        }, initOverrides);

        return new runtime.JSONApiResponse(response);
    }

    /**
     */
    async getVehicleHeaderCardDataByNewVehicleId(requestParameters: GetVehicleHeaderCardDataByNewVehicleIdRequest, initOverrides?: RequestInit | runtime.InitOverrideFunction): Promise<VehicleHeaderCardDTO> {
        const response = await this.getVehicleHeaderCardDataByNewVehicleIdRaw(requestParameters, initOverrides);
        return await response.value();
    }

    /**
     */
    async getVehicleHeaderCardDataByVinRaw(requestParameters: GetVehicleHeaderCardDataByVinRequest, initOverrides?: RequestInit | runtime.InitOverrideFunction): Promise<runtime.ApiResponse<VehicleHeaderCardDTO>> {
        if (requestParameters['publicBotId'] == null) {
            throw new runtime.RequiredError(
                'publicBotId',
                'Required parameter "publicBotId" was null or undefined when calling getVehicleHeaderCardDataByVin().'
            );
        }

        if (requestParameters['vin'] == null) {
            throw new runtime.RequiredError(
                'vin',
                'Required parameter "vin" was null or undefined when calling getVehicleHeaderCardDataByVin().'
            );
        }

        if (requestParameters['locale'] == null) {
            throw new runtime.RequiredError(
                'locale',
                'Required parameter "locale" was null or undefined when calling getVehicleHeaderCardDataByVin().'
            );
        }

        const queryParameters: any = {};

        if (requestParameters['locale'] != null) {
            queryParameters['locale'] = requestParameters['locale'];
        }

        const headerParameters: runtime.HTTPHeaders = {};

        const response = await this.request({
            path: `/api/public/widget/vehicle-header-card/bot/{publicBotId}/vin/{vin}`.replace(`{${"publicBotId"}}`, encodeURIComponent(String(requestParameters['publicBotId']))).replace(`{${"vin"}}`, encodeURIComponent(String(requestParameters['vin']))),
            method: 'GET',
            headers: headerParameters,
            query: queryParameters,
        }, initOverrides);

        return new runtime.JSONApiResponse(response);
    }

    /**
     */
    async getVehicleHeaderCardDataByVin(requestParameters: GetVehicleHeaderCardDataByVinRequest, initOverrides?: RequestInit | runtime.InitOverrideFunction): Promise<VehicleHeaderCardDTO> {
        const response = await this.getVehicleHeaderCardDataByVinRaw(requestParameters, initOverrides);
        return await response.value();
    }

    /**
     */
    async getVehicleHeaderCardDataByVrmRaw(requestParameters: GetVehicleHeaderCardDataByVrmRequest, initOverrides?: RequestInit | runtime.InitOverrideFunction): Promise<runtime.ApiResponse<VehicleHeaderCardDTO>> {
        if (requestParameters['publicBotId'] == null) {
            throw new runtime.RequiredError(
                'publicBotId',
                'Required parameter "publicBotId" was null or undefined when calling getVehicleHeaderCardDataByVrm().'
            );
        }

        if (requestParameters['vrm'] == null) {
            throw new runtime.RequiredError(
                'vrm',
                'Required parameter "vrm" was null or undefined when calling getVehicleHeaderCardDataByVrm().'
            );
        }

        if (requestParameters['locale'] == null) {
            throw new runtime.RequiredError(
                'locale',
                'Required parameter "locale" was null or undefined when calling getVehicleHeaderCardDataByVrm().'
            );
        }

        const queryParameters: any = {};

        if (requestParameters['locale'] != null) {
            queryParameters['locale'] = requestParameters['locale'];
        }

        const headerParameters: runtime.HTTPHeaders = {};

        const response = await this.request({
            path: `/api/public/widget/vehicle-header-card/bot/{publicBotId}/vrm/{vrm}`.replace(`{${"publicBotId"}}`, encodeURIComponent(String(requestParameters['publicBotId']))).replace(`{${"vrm"}}`, encodeURIComponent(String(requestParameters['vrm']))),
            method: 'GET',
            headers: headerParameters,
            query: queryParameters,
        }, initOverrides);

        return new runtime.JSONApiResponse(response);
    }

    /**
     */
    async getVehicleHeaderCardDataByVrm(requestParameters: GetVehicleHeaderCardDataByVrmRequest, initOverrides?: RequestInit | runtime.InitOverrideFunction): Promise<VehicleHeaderCardDTO> {
        const response = await this.getVehicleHeaderCardDataByVrmRaw(requestParameters, initOverrides);
        return await response.value();
    }

    /**
     */
    async getWidgetSettingsRaw(requestParameters: GetWidgetSettingsRequest, initOverrides?: RequestInit | runtime.InitOverrideFunction): Promise<runtime.ApiResponse<WidgetSettings>> {
        if (requestParameters['publicBotId'] == null) {
            throw new runtime.RequiredError(
                'publicBotId',
                'Required parameter "publicBotId" was null or undefined when calling getWidgetSettings().'
            );
        }

        const queryParameters: any = {};

        if (requestParameters['locale'] != null) {
            queryParameters['locale'] = requestParameters['locale'];
        }

        if (requestParameters['ignoreConversationLimits'] != null) {
            queryParameters['ignoreConversationLimits'] = requestParameters['ignoreConversationLimits'];
        }

        const headerParameters: runtime.HTTPHeaders = {};

        const response = await this.request({
            path: `/api/public/widget/settings/{publicBotId}`.replace(`{${"publicBotId"}}`, encodeURIComponent(String(requestParameters['publicBotId']))),
            method: 'GET',
            headers: headerParameters,
            query: queryParameters,
        }, initOverrides);

        return new runtime.JSONApiResponse(response);
    }

    /**
     */
    async getWidgetSettings(requestParameters: GetWidgetSettingsRequest, initOverrides?: RequestInit | runtime.InitOverrideFunction): Promise<WidgetSettings> {
        const response = await this.getWidgetSettingsRaw(requestParameters, initOverrides);
        return await response.value();
    }

    /**
     */
    async initializeUserRaw(requestParameters: InitializeUserRequest, initOverrides?: RequestInit | runtime.InitOverrideFunction): Promise<runtime.ApiResponse<WidgetUserInitializationResponse>> {
        if (requestParameters['publicBotId'] == null) {
            throw new runtime.RequiredError(
                'publicBotId',
                'Required parameter "publicBotId" was null or undefined when calling initializeUser().'
            );
        }

        const queryParameters: any = {};

        const headerParameters: runtime.HTTPHeaders = {};

        const response = await this.request({
            path: `/api/public/widget/{publicBotId}/initialize-user`.replace(`{${"publicBotId"}}`, encodeURIComponent(String(requestParameters['publicBotId']))),
            method: 'POST',
            headers: headerParameters,
            query: queryParameters,
        }, initOverrides);

        return new runtime.JSONApiResponse(response);
    }

    /**
     */
    async initializeUser(requestParameters: InitializeUserRequest, initOverrides?: RequestInit | runtime.InitOverrideFunction): Promise<WidgetUserInitializationResponse> {
        const response = await this.initializeUserRaw(requestParameters, initOverrides);
        return await response.value();
    }

    /**
     */
    async queryRaw(requestParameters: QueryRequest, initOverrides?: RequestInit | runtime.InitOverrideFunction): Promise<runtime.ApiResponse<WidgetChatResponse>> {
        if (requestParameters['widgetChatRequest'] == null) {
            throw new runtime.RequiredError(
                'widgetChatRequest',
                'Required parameter "widgetChatRequest" was null or undefined when calling query().'
            );
        }

        const queryParameters: any = {};

        const headerParameters: runtime.HTTPHeaders = {};

        headerParameters['Content-Type'] = 'application/json';

        const response = await this.request({
            path: `/api/public/widget/query`,
            method: 'POST',
            headers: headerParameters,
            query: queryParameters,
            body: requestParameters['widgetChatRequest'],
        }, initOverrides);

        return new runtime.JSONApiResponse(response);
    }

    /**
     */
    async query(requestParameters: QueryRequest, initOverrides?: RequestInit | runtime.InitOverrideFunction): Promise<WidgetChatResponse> {
        const response = await this.queryRaw(requestParameters, initOverrides);
        return await response.value();
    }

    /**
     */
    async saveInitialBotMessageRaw(requestParameters: SaveInitialBotMessageOperationRequest, initOverrides?: RequestInit | runtime.InitOverrideFunction): Promise<runtime.ApiResponse<WidgetChatInitializeResponse>> {
        if (requestParameters['chatId'] == null) {
            throw new runtime.RequiredError(
                'chatId',
                'Required parameter "chatId" was null or undefined when calling saveInitialBotMessage().'
            );
        }

        if (requestParameters['saveInitialBotMessageRequest'] == null) {
            throw new runtime.RequiredError(
                'saveInitialBotMessageRequest',
                'Required parameter "saveInitialBotMessageRequest" was null or undefined when calling saveInitialBotMessage().'
            );
        }

        const queryParameters: any = {};

        const headerParameters: runtime.HTTPHeaders = {};

        headerParameters['Content-Type'] = 'application/json';

        const response = await this.request({
            path: `/api/public/widget/{chatId}/save-initial-bot-message`.replace(`{${"chatId"}}`, encodeURIComponent(String(requestParameters['chatId']))),
            method: 'POST',
            headers: headerParameters,
            query: queryParameters,
            body: requestParameters['saveInitialBotMessageRequest'],
        }, initOverrides);

        return new runtime.JSONApiResponse(response);
    }

    /**
     */
    async saveInitialBotMessage(requestParameters: SaveInitialBotMessageOperationRequest, initOverrides?: RequestInit | runtime.InitOverrideFunction): Promise<WidgetChatInitializeResponse> {
        const response = await this.saveInitialBotMessageRaw(requestParameters, initOverrides);
        return await response.value();
    }

    /**
     */
    async saveMessageFeedbackRaw(requestParameters: SaveMessageFeedbackOperationRequest, initOverrides?: RequestInit | runtime.InitOverrideFunction): Promise<runtime.ApiResponse<void>> {
        if (requestParameters['chatId'] == null) {
            throw new runtime.RequiredError(
                'chatId',
                'Required parameter "chatId" was null or undefined when calling saveMessageFeedback().'
            );
        }

        if (requestParameters['messageId'] == null) {
            throw new runtime.RequiredError(
                'messageId',
                'Required parameter "messageId" was null or undefined when calling saveMessageFeedback().'
            );
        }

        if (requestParameters['saveMessageFeedbackRequest'] == null) {
            throw new runtime.RequiredError(
                'saveMessageFeedbackRequest',
                'Required parameter "saveMessageFeedbackRequest" was null or undefined when calling saveMessageFeedback().'
            );
        }

        const queryParameters: any = {};

        const headerParameters: runtime.HTTPHeaders = {};

        headerParameters['Content-Type'] = 'application/json';

        const response = await this.request({
            path: `/api/public/widget/{chatId}/messages/{messageId}/feedback`.replace(`{${"chatId"}}`, encodeURIComponent(String(requestParameters['chatId']))).replace(`{${"messageId"}}`, encodeURIComponent(String(requestParameters['messageId']))),
            method: 'PUT',
            headers: headerParameters,
            query: queryParameters,
            body: requestParameters['saveMessageFeedbackRequest'],
        }, initOverrides);

        return new runtime.VoidApiResponse(response);
    }

    /**
     */
    async saveMessageFeedback(requestParameters: SaveMessageFeedbackOperationRequest, initOverrides?: RequestInit | runtime.InitOverrideFunction): Promise<void> {
        await this.saveMessageFeedbackRaw(requestParameters, initOverrides);
    }

    /**
     */
    async saveSurveyRaw(requestParameters: SaveSurveyOperationRequest, initOverrides?: RequestInit | runtime.InitOverrideFunction): Promise<runtime.ApiResponse<void>> {
        if (requestParameters['chatId'] == null) {
            throw new runtime.RequiredError(
                'chatId',
                'Required parameter "chatId" was null or undefined when calling saveSurvey().'
            );
        }

        if (requestParameters['saveSurveyRequest'] == null) {
            throw new runtime.RequiredError(
                'saveSurveyRequest',
                'Required parameter "saveSurveyRequest" was null or undefined when calling saveSurvey().'
            );
        }

        const queryParameters: any = {};

        const headerParameters: runtime.HTTPHeaders = {};

        headerParameters['Content-Type'] = 'application/json';

        const response = await this.request({
            path: `/api/public/widget/{chatId}/survey`.replace(`{${"chatId"}}`, encodeURIComponent(String(requestParameters['chatId']))),
            method: 'POST',
            headers: headerParameters,
            query: queryParameters,
            body: requestParameters['saveSurveyRequest'],
        }, initOverrides);

        return new runtime.VoidApiResponse(response);
    }

    /**
     */
    async saveSurvey(requestParameters: SaveSurveyOperationRequest, initOverrides?: RequestInit | runtime.InitOverrideFunction): Promise<void> {
        await this.saveSurveyRaw(requestParameters, initOverrides);
    }

    /**
     */
    async setStopTranscriptSendingRaw(requestParameters: SetStopTranscriptSendingOperationRequest, initOverrides?: RequestInit | runtime.InitOverrideFunction): Promise<runtime.ApiResponse<void>> {
        if (requestParameters['chatId'] == null) {
            throw new runtime.RequiredError(
                'chatId',
                'Required parameter "chatId" was null or undefined when calling setStopTranscriptSending().'
            );
        }

        if (requestParameters['setStopTranscriptSendingRequest'] == null) {
            throw new runtime.RequiredError(
                'setStopTranscriptSendingRequest',
                'Required parameter "setStopTranscriptSendingRequest" was null or undefined when calling setStopTranscriptSending().'
            );
        }

        const queryParameters: any = {};

        const headerParameters: runtime.HTTPHeaders = {};

        headerParameters['Content-Type'] = 'application/json';

        const response = await this.request({
            path: `/api/public/widget/{chatId}/stop-transcript-sending`.replace(`{${"chatId"}}`, encodeURIComponent(String(requestParameters['chatId']))),
            method: 'PUT',
            headers: headerParameters,
            query: queryParameters,
            body: requestParameters['setStopTranscriptSendingRequest'],
        }, initOverrides);

        return new runtime.VoidApiResponse(response);
    }

    /**
     */
    async setStopTranscriptSending(requestParameters: SetStopTranscriptSendingOperationRequest, initOverrides?: RequestInit | runtime.InitOverrideFunction): Promise<void> {
        await this.setStopTranscriptSendingRaw(requestParameters, initOverrides);
    }

}

/**
 * @export
 */
export const GetPersonalizedVehicleDescriptionLocaleEnum = {
    EnGb: 'EN_GB',
    EnUs: 'EN_US',
    EnCa: 'EN_CA',
    FrFr: 'FR_FR',
    FrCa: 'FR_CA',
    DeDe: 'DE_DE',
    EsEs: 'ES_ES',
    JaJp: 'JA_JP',
    ArAe: 'AR_AE'
} as const;
export type GetPersonalizedVehicleDescriptionLocaleEnum = typeof GetPersonalizedVehicleDescriptionLocaleEnum[keyof typeof GetPersonalizedVehicleDescriptionLocaleEnum];
/**
 * @export
 */
export const GetVehicleDetailsCardContentLocaleEnum = {
    EnGb: 'EN_GB',
    EnUs: 'EN_US',
    EnCa: 'EN_CA',
    FrFr: 'FR_FR',
    FrCa: 'FR_CA',
    DeDe: 'DE_DE',
    EsEs: 'ES_ES',
    JaJp: 'JA_JP',
    ArAe: 'AR_AE'
} as const;
export type GetVehicleDetailsCardContentLocaleEnum = typeof GetVehicleDetailsCardContentLocaleEnum[keyof typeof GetVehicleDetailsCardContentLocaleEnum];
/**
 * @export
 */
export const GetVehicleDetailsCardContentByNewVehicleIdLocaleEnum = {
    EnGb: 'EN_GB',
    EnUs: 'EN_US',
    EnCa: 'EN_CA',
    FrFr: 'FR_FR',
    FrCa: 'FR_CA',
    DeDe: 'DE_DE',
    EsEs: 'ES_ES',
    JaJp: 'JA_JP',
    ArAe: 'AR_AE'
} as const;
export type GetVehicleDetailsCardContentByNewVehicleIdLocaleEnum = typeof GetVehicleDetailsCardContentByNewVehicleIdLocaleEnum[keyof typeof GetVehicleDetailsCardContentByNewVehicleIdLocaleEnum];
/**
 * @export
 */
export const GetVehicleHeaderCardDataByNewVehicleIdLocaleEnum = {
    EnGb: 'EN_GB',
    EnUs: 'EN_US',
    EnCa: 'EN_CA',
    FrFr: 'FR_FR',
    FrCa: 'FR_CA',
    DeDe: 'DE_DE',
    EsEs: 'ES_ES',
    JaJp: 'JA_JP',
    ArAe: 'AR_AE'
} as const;
export type GetVehicleHeaderCardDataByNewVehicleIdLocaleEnum = typeof GetVehicleHeaderCardDataByNewVehicleIdLocaleEnum[keyof typeof GetVehicleHeaderCardDataByNewVehicleIdLocaleEnum];
/**
 * @export
 */
export const GetVehicleHeaderCardDataByVinLocaleEnum = {
    EnGb: 'EN_GB',
    EnUs: 'EN_US',
    EnCa: 'EN_CA',
    FrFr: 'FR_FR',
    FrCa: 'FR_CA',
    DeDe: 'DE_DE',
    EsEs: 'ES_ES',
    JaJp: 'JA_JP',
    ArAe: 'AR_AE'
} as const;
export type GetVehicleHeaderCardDataByVinLocaleEnum = typeof GetVehicleHeaderCardDataByVinLocaleEnum[keyof typeof GetVehicleHeaderCardDataByVinLocaleEnum];
/**
 * @export
 */
export const GetVehicleHeaderCardDataByVrmLocaleEnum = {
    EnGb: 'EN_GB',
    EnUs: 'EN_US',
    EnCa: 'EN_CA',
    FrFr: 'FR_FR',
    FrCa: 'FR_CA',
    DeDe: 'DE_DE',
    EsEs: 'ES_ES',
    JaJp: 'JA_JP',
    ArAe: 'AR_AE'
} as const;
export type GetVehicleHeaderCardDataByVrmLocaleEnum = typeof GetVehicleHeaderCardDataByVrmLocaleEnum[keyof typeof GetVehicleHeaderCardDataByVrmLocaleEnum];
/**
 * @export
 */
export const GetWidgetSettingsLocaleEnum = {
    EnGb: 'EN_GB',
    EnUs: 'EN_US',
    EnCa: 'EN_CA',
    FrFr: 'FR_FR',
    FrCa: 'FR_CA',
    DeDe: 'DE_DE',
    EsEs: 'ES_ES',
    JaJp: 'JA_JP',
    ArAe: 'AR_AE'
} as const;
export type GetWidgetSettingsLocaleEnum = typeof GetWidgetSettingsLocaleEnum[keyof typeof GetWidgetSettingsLocaleEnum];
